import { z } from "zod";
const GOVERNORATES = [
  "tunis",
  "ariana",
  "ben_arous",
  "manouba",
  "nabeul",
  "zaghouan",
  "bizerte",
  "beja",
  "jendouba",
  "kef",
  "siliana",
  "kairouan",
  "kasserine",
  "sidi_bouzid",
  "sousse",
  "monastir",
  "mahdia",
  "sfax",
  "gafsa",
  "tozeur",
  "kebili",
  "gabes",
  "medenine",
  "tataouine"
];
const GovernorateSchema = z.enum(GOVERNORATES);
const DISCIPLINES = [
  "architecture",
  "structure",
  "vrd",
  "fluides",
  "electricite",
  "topographie",
  "geotechnique",
  "opc"
];
const DisciplineSchema = z.enum(DISCIPLINES);
const AddressSchema = z.strictObject({
  line1: z.string().trim().min(1).max(200),
  line2: z.string().trim().max(200).optional(),
  city: z.string().trim().min(1).max(100),
  postalCode: z.string().trim().regex(/^[0-9A-Za-z -]{3,10}$/),
  /** ISO 3166-1 alpha-2; Tunisia by default. */
  country: z.string().regex(/^[A-Z]{2}$/).default("TN")
});
export {
  AddressSchema,
  DISCIPLINES,
  DisciplineSchema,
  GOVERNORATES,
  GovernorateSchema
};
//# sourceMappingURL=tunisia.js.map